//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'
import Multiselect from 'vue-multiselect'

import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { Cookies } from '@/scripts/libs/cookies'
import {
  adjustRoeCookies,
  getRoeCookie,
  getSortedCountries,
  removeRoeCookie,
  removeSetCurrencyCookie,
  roeCurrencies,
  setCurrencyPreference,
  setRoeCookie,
  setRoeCurrencyCookieAndLocalStorage,
} from '@/scripts/libs/country-selector'
import { TRACKER_CLICK, TRACKER_COUNTRY_SELECTOR_OVERLAY } from '@/scripts/constants/tracker'
import { MOBILE, DESKTOP, TABLET } from '@/scripts/constants/media-query'
import { AKA_CC, ROE_CC, COUNTRY_OVERLAY_FLAG } from '@/scripts/constants/cookies'
import { EVENTS, MODAL_WRAPPER__FOOTER } from '@/scripts/constants/css-classes'
import { ACTION_INCREMENT_NO_ECOMMERCE_COUNTER } from '@/scripts/store/actions'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'
import { Url } from '@/scripts/libs/url'

const EU = '/eu'

export default {
  name: 'rb-country-overlay',
  components: {
    RbModal,
    Multiselect,
  },
  props: {
    dataStoreId: String,
    paymentmethodsUrl: String,
  },
  data: function () {
    return {
      akamaiCookie: undefined,
      akamaiCountry: undefined,
      akamaiCountryURL: undefined,
      akamaiCountryURLToPrint: undefined,
      benefit: null,
      benefitsLabel: null,
      currency: null,
      currencyLabel: null,
      currentCountryIso: undefined,
      destinationCountryIso: undefined,
      filteredLocales: [],
      hasError: false,
      isVisible: false,
      loading: false,
      locales: [],
      modalActive: false,
      paymentsLabel: null,
      paymentsMethod: [],
      requestedCountry: undefined,
      requestedCountryURL: undefined,
      requestedCountryURLToPrint: undefined,
      roeCookie: undefined,
      roeCountries: [],
      roeCurrency: undefined,
      roeErrorMessage: undefined,
      selectedCountry: undefined,
      selectedRoeCountry: undefined,
      shippingLabel: undefined,
      submitLabel: null,
      titleLabel: null,
      typeLabel: null,
      MOBILE,
      noEcomCookie: undefined,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    paymentMethodsAvailable() {
      return this.paymentsMethod.length > 0
    },
    currencyAvailable() {
      if (this.currency) {
        return this.currency.length > 0
      } else {
        return false
      }
    },
    openDirection() {
      return this.$mq === DESKTOP ? 'bottom' : 'top'
    },
    isRoeSelectorNeeded() {
      let roeCookie = this.getRoeCookie()
      const akaCC = this.getAkamaiCookie()
      return Url.isCountryInUrl(EU) && !roeCookie && !Object.keys(roeCurrencies).includes(akaCC)
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    isCountrySelectorNeededForRoe() {
      return this.isRoeSelectorNeeded
    },
  },
  watch: {
    requestedCountry: function () {
      this.loading = true
      if (
        this.paymentmethodsUrl &&
        this.requestedCountry?.id &&
        !NoEcommerce.isStoreInNoEcommerceCountries(this.requestedCountry?.akamaiCC)
      ) {
        axios
          .get(this.paymentmethodsUrl, {
            params: {
              storeId: this.requestedCountry.id,
              langId: this.requestedCountry.langId,
            },
          })
          .then(({ data }) => {
            // country with storeID and payment methods available
            if (this.requestedCountry?.labels) {
              this.currencyLabel = this.requestedCountry.labels.currencyLabel
              this.paymentsLabel = this.requestedCountry.labels.paymentsLabel
              this.benefitsLabel = this.requestedCountry.labels.benefitsLabel
              this.shippingLabel = this.requestedCountry.labels.shippingLabel
              this.submitLabel = this.requestedCountry.labels.submitLabel
              this.titleLabel = this.requestedCountry.labels.titleLabel
              this.typeLabel = this.requestedCountry.labels.typeLabel
              this.roeErrorMessage = this.requestedCountry.labels.roeErrorMessage || ''
            }
            this.paymentsMethod = data.payment.paymentsMethod
            this.currency = this.requestedCountry.currency
            this.benefit = data.benefit
            this.loading = false
          })
      } else if (!this.requestedCountry) {
        // case same country
        this.loading = false
      } else {
        this.paymentsMethod = ''
        this.benefit = ''
        this.benefitsLabel = ''
        this.currency = this.requestedCountry.currency
        this.currencyLabel =
          this.requestedCountry.labels && this.requestedCountry.labels.currencyLabel
        this.shippingLabel =
          this.requestedCountry.labels && this.requestedCountry.labels.shippingLabel
        this.submitLabel = this.requestedCountry?.labels?.submitLabel
        this.titleLabel = this.requestedCountry?.labels?.titleLabel
        this.typeLabel = this.requestedCountry?.labels?.typeLabel
        this.roeErrorMessage = this.requestedCountry?.labels?.roeErrorMessage || ''
        this.loading = false
      }
    },
  },
  created() {
    this.checkAndCleanOverlayCookie()
    NoEcommerce.checkAndCleanNoEcommerceCookie()
    NoEcommerce.checkAndAddNoEcommerceCookie()
    this.incrementNoEcommerceCounter()
  },
  mounted: function () {
    const isEu = document.getElementById(ROE_CC)
    const euId = (isEu && isEu.value) || undefined
    let roeCookie = this.getRoeCookie()
    let noEcomCookie = this.getNoEcomCookie()
    if (roeCookie) {
      if (!Url.isCountryInUrl(EU)) {
        if (!euId) {
          removeRoeCookie()
          removeSetCurrencyCookie()
          if (!NoEcommerce.isStoreNoEcommerce()) {
            this.cleanNoEcommerceCookieAndLocalStorage()
          }
        }
      } else {
        adjustRoeCookies()
      }
    }
    const akamaiCookie = this.getAkamaiCookie()
    const akamaiNoEcomCookie = this.getAkamaiCookieNoEcom()
    roeCookie = this.getRoeCookie()
    noEcomCookie = this.getNoEcomCookie()
    const overlayCookie = this.getOverlayCookie()
    const isRoeCookieEqualToAkamaiCookie = roeCookie === akamaiCookie
    const isNoEcomCookieEqualToAkamaiCookie = noEcomCookie === akamaiNoEcomCookie
    const isOverlayForRoeNeeded = overlayCookie !== 'true' && !isRoeCookieEqualToAkamaiCookie
    const isOverlayForNoEcomNeeded = overlayCookie !== 'true' && !isNoEcomCookieEqualToAkamaiCookie
    if (
      (!overlayCookie && akamaiCookie) ||
      (euId && !roeCookie) ||
      isOverlayForRoeNeeded ||
      isOverlayForNoEcomNeeded
    ) {
      this.overlayInit()
    }
  },
  beforeDestroy() {
    document.body.removeEventListener(EVENTS.CLICK, () => {
      this.bindClick()
    })
  },

  destroyed: function () {
    Cookies.set(COUNTRY_OVERLAY_FLAG, true)
    localStorage.setItem(COUNTRY_OVERLAY_FLAG, true)
  },
  methods: {
    ...mapActions({
      incrementNoEcommerceCounter: ACTION_INCREMENT_NO_ECOMMERCE_COUNTER,
    }),
    bindClick() {
      if (!this.isVisible) {
        this.hasError = true
      }
    },
    changeCountry(event) {
      if (!event) return
      this.requestedCountry = event
      this.currentCountryIso = this.getIsoCountry(this.requestedCountry)
      // analytics 2020
      this.$ma.trackEvent({
        event: TRACKER_COUNTRY_SELECTOR_OVERLAY,
        value: {
          Cso_Action: 'Switch',
          Cso_Destination: this.currentCountryIso,
        },
      })
      if (document.domain.includes('.cn')) {
        const urlreplaced = window.location.origin.replace('.cn', '')
        this.requestedCountryURL = urlreplaced + this.requestedCountry.url
        this.requestedCountryURLToPrint =
          window.location.pathname.replace('.cn', '') + this.requestedCountry.url
      } else {
        if (NoEcommerce.isStoreInNoEcommerceCountries(this.requestedCountry.akamaiCC)) {
          NoEcommerce.setNoEcommerceCookie(this.requestedCountry.akamaiCC)
        }
        this.requestedCountryURL = this.createNavigationURL(this.requestedCountry.url)
        this.requestedCountryURLToPrint = this.getTopDomain() + this.requestedCountry.url
      }
      window.location.href = this.requestedCountryURL
      this.closeModal()
    },
    changeRoeCountry(event) {
      if (!event) return
      this.hasError = false
      this.requestedCountry = event
      this.currentCountryIso = this.getIsoCountry(this.requestedCountry)
      if (document.domain.includes('.cn')) {
        const urlreplaced = window.location.origin.replace('.cn', '')
        this.requestedCountryURL = urlreplaced + this.requestedCountry.url
        this.requestedCountryURLToPrint =
          window.location.pathname.replace('.cn', '') + this.requestedCountry.url
      } else {
        this.requestedCountryURL = this.createNavigationURL(this.requestedCountry.url)
        this.requestedCountryURLToPrint = this.getTopDomain() + this.requestedCountry.url
      }

      if (this.requestedCountryURL) {
        this.isVisible = true
      }
    },
    closeModal: function () {
      Cookies.set(COUNTRY_OVERLAY_FLAG, true)
      localStorage.setItem(COUNTRY_OVERLAY_FLAG, true)
      if (this.requestedCountry?.akamaiCC) {
        if (this.roeCookie) {
          setRoeCurrencyCookieAndLocalStorage
          setRoeCookie(this.requestedCountry.akamaiCC)
        } else if (this.noEcomCookie) {
          NoEcommerce.setNoEcommerceCookie(this.requestedCountry.akamaiCC)
        }
      }
      this.modalActive = false

      //This is a workaround for avoiding error on mobile
      if (this.isMobile) {
        const modalFooter = document?.getElementsByClassName(MODAL_WRAPPER__FOOTER)[0]
        modalFooter?.style?.removeProperty('z-index')
      }
    },
    createNavigationURL(path) {
      if (window.location.origin.includes('.cn') && path !== '/zh') {
        const origin = window.location.origin.replace('.cn', '')
        return origin
      } else {
        return window.location.origin + path
      }
    },
    findCoincidences(searchQuery) {
      const val = searchQuery.trim().toLowerCase()

      this.filteredLocales = this.locales.filter((localItem) => {
        const label = localItem.label.toLowerCase()
        const synonymous = localItem.synonymous.filter((synonym) => {
          return synonym.toLowerCase().startsWith(val)
        })
        return label.startsWith(val) || synonymous.length > 0
      })
    },
    fillLocales(locales) {
      this.locales = locales
      this.findCoincidences('')
    },
    getAkamaiCookie() {
      return (this.akamaiCookie = Cookies.get(AKA_CC))
    },
    getAkamaiCookieNoEcom() {
      return (this.akamaiNoEcomCookie = NoEcommerce.getNoEcommerceCountry())
    },
    getCountryByAkamaiCC(cc) {
      if (!cc) return undefined
      return this.locales.find((locale) => locale.akamaiCC === cc)
    },
    getCountryById(id) {
      const filteredCountry = this.locales.filter((locale) => {
        if (locale.akamaiCC && this.getRoeCookie()) {
          return locale.akamaiCC === this.getRoeCookie()
        } else if (locale.akamaiCC && this.getNoEcomCookie()) {
          return locale.akamaiCC === this.getNoEcomCookie()
        }
        return locale.id === id
      })

      if (filteredCountry.length > 1) {
        const countryByPath = filteredCountry.filter((country) => {
          return country && Url.isCountryInUrl(country.url)
        })
        return countryByPath[0]
      }

      return filteredCountry[0]
    },
    getCountryByIso(iso) {
      return this.locales.find(
        (locale) => iso && locale.iconFlag && locale.iconFlag.includes(iso.toLowerCase())
      )
    },
    getIsoCountry(country) {
      if (!country) return undefined
      return country.lang.split('-')[1]
    },
    getRoeCookie() {
      return (this.roeCookie = getRoeCookie())
    },
    getRoeCountries() {
      const url = EU
      this.roeCountries = this.locales.filter((locale) => locale.url === url)
      const roeCountry = this.roeCountries.find((country) => country.akamaiCC === this.akamaiCookie)
      if (roeCountry) {
        setRoeCookie(this.akamaiCookie)
      }
    },
    getNoEcomCookie() {
      const noEcommerceCookie = NoEcommerce.getNoEcommerceCountry()
      return (this.noEcomCookie = noEcommerceCookie || noEcommerceCookie)
    },
    getNoEcomCountries() {
      const noEcomCountry = this.locales.find(
        (country) => country.akamaiCC === this.akamaiNoEcomCookie
      )
      if (noEcomCountry) {
        NoEcommerce.setNoEcommerceCookie(this.akamaiNoEcomCookie)
      }
    },

    getTopDomain() {
      const domain = document?.domain?.replace('.cn', '').split('.')
      return domain[domain.length - 2] + '.' + domain[domain.length - 1]
    },
    showRoeSelector(url) {
      const roeInput = document.getElementById(ROE_CC) || undefined
      const roeCC = roeInput ? roeInput.value : undefined
      if (roeCC || url.includes(EU)) {
        const roeCountry = this.roeCountries.find(
          (country) => country.akamaiCC === this.akamaiCookie
        )
        if (roeCountry) {
          return false
        }
        return true
      }
      return false
    },
    navigateToRequestedCountry(isoDestination) {
      this.pushFlagOverlayDataForTealium(isoDestination)
      this.closeModal()
    },
    openModal() {
      this.modalActive = true

      //This is a workaround for avoiding error on mobile
      if (this.isMobile) {
        const modalFooter = document.getElementsByClassName(MODAL_WRAPPER__FOOTER)[0]
        if (modalFooter && modalFooter.style) {
          modalFooter.style.zIndex = '0'
        }
      }

      //analytics 2020
      this.$ma.trackEvent({
        event: TRACKER_COUNTRY_SELECTOR_OVERLAY,
        value: {
          Cso_Action: 'Open',
        },
      })
    },
    overlayInit() {
      const actualCountryFromAkamai = this.getAkamaiCookie()
      const requestWebSite = this.dataStoreId

      this.fillLocales(getSortedCountries())
      this.akamaiCountry = this.getCountryByIso(actualCountryFromAkamai)
      this.requestedCountry = this.getCountryById(requestWebSite)
      this.currentCountryIso = this.getIsoCountry(this.requestedCountry)
      this.destinationCountryIso = actualCountryFromAkamai
      this.akamaiCountryURL = this.createNavigationURL(this.akamaiCountry?.url)
      this.akamaiCountryURLToPrint = this.getTopDomain() + this.akamaiCountry?.url
      this.requestedCountryURL = this.createNavigationURL(this.requestedCountry?.url)
      this.requestedCountryURLToPrint = this.getTopDomain() + this.requestedCountry?.url

      this.getRoeCountries()

      this.getNoEcomCountries()

      if (this.akamaiCountry && this.akamaiCountry?.id !== this.requestedCountry?.id) {
        this.openModal()
        document.body.addEventListener(EVENTS.CLICK, () => {
          this.bindClick()
        })
      } else {
        this.selectCountry(false)
      }
    },
    selectCountry(canRedirect) {
      if (this.requestedCountryURL) {
        if (this.requestedCountry?.akamaiCC) {
          localStorage.clear()
          sessionStorage.clear()

          const requestedCC = this.requestedCountry?.akamaiCC

          const isRequestedStoreNoEcommerce = NoEcommerce.isStoreInNoEcommerceCountries(requestedCC)
          if (this.requestedCountry.id === WcsStoreId.REST_OF_EUROPE) {
            removeRoeCookie()
            setRoeCookie(requestedCC)
            this.getRoeCookie()
            this.roeCurrency = this.requestedCountry.currencyROEValue
            setCurrencyPreference(
              this.closeModal(),
              this.requestedCountryURL,
              requestedCC,
              this.requestedCountry.currencyROEValue,
              canRedirect
            )
          } else if (isRequestedStoreNoEcommerce) {
            this.cleanNoEcommerceCookieAndLocalStorage()
            NoEcommerce.setNoEcommerceCookie(requestedCC)
            setCurrencyPreference(
              this.closeModal(),
              this.requestedCountryURL,
              requestedCC,
              null,
              canRedirect
            )
          }
        }
      }
    },
    getOverlayCookie() {
      return localStorage.getItem(COUNTRY_OVERLAY_FLAG) || Cookies.get(COUNTRY_OVERLAY_FLAG)
    },
    cleanOverlayCookie() {
      localStorage.removeItem(COUNTRY_OVERLAY_FLAG)
      Cookies.remove(COUNTRY_OVERLAY_FLAG)
      this.incrementNoEcommerceCounter()
    },
    checkAndCleanOverlayCookie() {
      if (this.isCountrySelectorNeededForRoe) {
        this.cleanOverlayCookie()
      }
    },
    cleanNoEcommerceCookieAndLocalStorage() {
      NoEcommerce.removeNoEcommerceCookie()
      this.incrementNoEcommerceCounter()
    },
    pushFlagOverlayDataForTealium(countryLabel) {
      this.$ma.trackEvent({
        event: TRACKER_CLICK,
        value: {
          data_element_id: TRACKER_COUNTRY_SELECTOR_OVERLAY,
          data_description: countryLabel,
        },
      })
    },
  },
}
